<template>
  <Checkbox
    :rules="rules"
    :label="label"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  props: {
    label: String,
    value: [String, Object, Number, Boolean],
    rules: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style></style>
